import { render, staticRenderFns } from "./newchilddealer.vue?vue&type=template&id=05d39f3c&"
import script from "./newchilddealer.vue?vue&type=script&lang=js&"
export * from "./newchilddealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports